module.exports = "<p>קודם כל, תודה שאכפת לכם. במידה ומצאתם פרטים שגויים או מודעות פיקטיביות, ספרו לנו על כך! תוכלו לעשות זאת בעמוד &quot;צור קשר&quot;, אותו תמצאו בתחתית האתר.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/14.md
// module id = 806
// module chunks = 0